// @flow

import Timer from '@/lib/timer';
import VirtualTime from '@/lib/virtual_time';
import Cell from '@/lib/cell';
import CellManager from '@/lib/cell_manager';
import UnitManager from '@/lib/unit_manager';
import AssetManager from '@/lib/asset_manager';
import UserAction from '@/lib/user_action';
import NotificationManager from '@/lib/notification_manager';
import AchievementManager from '@/lib/achievement_manager';
import Tutorial from '@/lib/tutorial';
import StatsManager from '@/lib/stats_manager';
import Shop from '@/lib/shop';
import { DefaultEvent } from '@/lib/game_event';
import Settings from '@/lib/settings';
import WaveObserver from '@/lib/wave_observer';

export default class {
  stop: boolean;
  virtualTime: VirtualTime;
  cellManager: CellManager;
  unitManager: UnitManager;
  assetManager: AssetManager;
  userAction: UserAction;
  notificationManager: NotificationManager;
  achievementManager: AchievementManager;
  tutorial: Tutorial;
  shop: Shop;
  events: GameEventCallable[];
  speedRate: number;
  statsManager: StatsManager;
  waveObserver: WaveObserver;

  constructor() {
    this.virtualTime = new VirtualTime();
    this.cellManager = new CellManager(this);
    this.unitManager = new UnitManager(this);
    this.assetManager = new AssetManager(this);
    this.userAction = new UserAction(this);
    this.notificationManager = new NotificationManager();
    this.achievementManager = new AchievementManager(this);
    this.tutorial = new Tutorial(this);
    this.statsManager = new StatsManager(this);
    this.shop = new Shop(this);
    this.waveObserver = new WaveObserver(this);
    this.stop = false;
    this.events = [DefaultEvent];
    this.speedRate = 1;
  }

  get cells() {
    return this.cellManager.cells;
  }

  get units() {
    return this.unitManager.units;
  }

  get notifications() {
    return this.notificationManager.notifications;
  }

  get achievements() {
    return this.achievementManager.achievements;
  }

  get tutorials() {
    return this.tutorial.messages;
  }

  get stats(): Stats {
    return this.statsManager.stats;
  }

  findCell(...condition: any) {
    return this.cellManager.find(...condition);
  }

  findUnit(condition: any) {
    return this.unitManager.find(condition);
  }

  notify(callback: NotificationManager => void) {
    callback(this.notificationManager);
  }

  readNotification(notificationId: number) {
    this.notificationManager.remove(notificationId);
  }

  doUserAction(actionName: string, conditions?: { [string]: any }) {
    this.userAction.do(actionName, conditions);
  }

  readTutorial(tutorialUid: string) {
    this.tutorial.remove(tutorialUid);
  }

  addObserverActions(actions: { [string]: () => void }) {
    this.waveObserver.setActions(actions);
  }

  async main(): Promise<void> {
    while (true) {
      const interval = Settings.defaultVirtualTimeInterval / this.speedRate;
      await Timer.sleep(interval);

      if (!this.stop) {
        this.wave();
      }
    }
  }

  async wave(): Promise<void> {
    this.statsManager.calculate();
    this.waveObserver.perform();
    this.events.forEach(event => {
      // 登録されているイベントを順番に評価していき、最初に実行された段階で処理を終了する。
      // 必ず DefaultEvent が呼ばれてしまうのを避けるための仕組みで、特定の処理の後にデフォルト
      // の処理も行いたければ、それぞれの処理の中で DefaultEvent を呼び出す必要がある。
      if (event.shouldProcess(this)) {
        event.process(this);
        return;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/game/game.js